/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_EmptyInputs */

const cs_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné články.`)
};

const en_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No blog posts yet.`)
};

/**
* | output |
* | --- |
* | "No blog posts yet." |
*
* @param {Blog_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_empty = /** @type {((inputs?: Blog_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_empty(inputs)
	return cs_blog_empty(inputs)
});